import React from "react";

/**
 * @param {{ ticketNumber: string, ticket: { id: number }, onOpenTicket: (ticket: { id: number }) => void }} props
 */
export default function TicketNumberButton({ ticketNumber, ticket, onOpenTicket }) {
  if (!onOpenTicket || ticketNumber === "—") {
    return ticketNumber;
  }

  return (
    <button
      type="button"
      className="link-row cursor-pointer border-0 bg-transparent p-0 text-left font-inherit"
      onClick={() => onOpenTicket(ticket)}
    >
      {ticketNumber}
    </button>
  );
}
